(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("mask-layer", [], factory);
	else if(typeof exports === 'object')
		exports["mask-layer"] = factory();
	else
		root["mask-layer"] = factory();
})(self, function() {
return 